<style lang="scss" scoped>
    .line-title {
        display: flex;
        align-items: center;
        font-weight: 300;
        text-transform: uppercase;
        color: $white;
        text-align: center;

        &:before,
        &:after {
            content: '';
            display: block;
            height: 1px;
            flex: 1 1 100%;
            background-repeat: no-repeat;
            background-size: 100% 1px;
        }

        &:before {
            margin-right: 2%;
            background-position: right;
            background-image: url('/img/icons/left-line-white.svg');
        }

        &:after {
            margin-left: 2%;
            background-position: left;
            background-image: url('/img/icons/right-line-white.svg');
        }
    }
</style>
<template>
    <div class="line-title">
        {{title}}
    </div>
</template>
<script>
export default {
    name: 'LineTitle',
    props: {
        title: {
            type: String,
            required: true,
        },
    },
}
</script>
